import { render, staticRenderFns } from "./ChangeSummary.vue?vue&type=template&id=86fe76c0&"
import script from "./ChangeSummary.vue?vue&type=script&lang=js&"
export * from "./ChangeSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports